import React from 'react';
import { Box, Tabs } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';
import { useStyles } from './styles/styles';
import CustomTab from './components/CustomTab';
import { NAV_TABS } from './constansts';

const NavigationTab = () => {
  const { id } = useParams();
  const location = useLocation();
  const classes = useStyles();
  const acitveTab = NAV_TABS.findIndex((tab) => location?.pathname.includes(tab.path));
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
      <Tabs className={classes.rootTab} value={acitveTab}>
        {NAV_TABS.map((tab) => (
          <CustomTab key={tab.label} label={tab.label} to={`${tab.path}/${id}`} />
        ))}
      </Tabs>
    </Box>
  );
};

export default NavigationTab;
